export default "__VITE_ASSET__71811274__"